const root = "/permisos-sindicales/statistics";

const paths = {
  laborUnions: root.concat("/unions"),
  laborUnionsEmployees: root.concat("/unions/:union/employees"),
  laborUnionGraphicData: root.concat("/graphics-data"),
  laborUnionWorkerInformation: root.concat("/worker-information"),
  laborUnionDownloadReport: root.concat("/download-report"),
  periodConventionals: "/permisos-sindicales/conventional-periods/records",
  statisticsPayments: root.concat("/tickets-payments")
};

export { paths };
